function shouldRemoveUnApprovedView({ state, output }) {
  if (state.get('users.unapproved').length === 0) {
    output.true()
  } else {
    output.false()
  }
}
shouldRemoveUnApprovedView.outputs = ['true', 'false']

export default shouldRemoveUnApprovedView



// WEBPACK FOOTER //
// ./src/modules/user/actions/shouldRemoveUnApprovedView.js